module.exports = __webpack_public_path__ + "img/47.518860c0.png";